/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsorderdisputed2Inputs */

const en_ticketsorderdisputed2 = /** @type {(inputs: Ticketsorderdisputed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment disputed`)
};

const de_ticketsorderdisputed2 = /** @type {(inputs: Ticketsorderdisputed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung bestritten`)
};

/**
* | output |
* | --- |
* | "Payment disputed" |
*
* @param {Ticketsorderdisputed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsorderdisputed2 = /** @type {((inputs?: Ticketsorderdisputed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsorderdisputed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsorderdisputed2(inputs)
	return de_ticketsorderdisputed2(inputs)
});
export { ticketsorderdisputed2 as "ticketsOrderDisputed" }